import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-payment-flow', storeModule.createStoreModule('management-reports-payment-flow'))
